import { ChangelogData } from "@cervval.js/common/src/models/changelog.model";

export const mapToken = "AIzaSyALLdZfJbhg_a6OO6lQdBKWCy54op3kUw0";

export const DEFAULT_PRICE = 39.9;
export const APP_PRICE_RATE = 0.14;
export const APP_PRICE_MIN = 5;
export const mapID = "daf9f5a058040602";

export const PIXEL_META_ID = "1252553196434042";

const changelog = require("./sportsante.changelog.json") as ChangelogData;
export const LastVersion = changelog?.versions[0]?.uid ?? "no-versioning";

/** Global endpoint where every server functions are located */
export const APPLICATION_ENDPOINT = "/app";

/** 
 * Id of the `CompanyDTO` of Activmed
 * TODO Remove and use a variable taken from server environment
 * @deprecated
 */
export const ACTIVMED_COMPANY_ID = 1;

/** Max value that can be stored with PostGreSQL SMALLINT numeric type */
export const PGSQL_SMALLINT_MAX_VALUE = 32767;